// extracted by mini-css-extract-plugin
var _1 = "back-_9qyK";
var _2 = "body-tCjKJ";
var _3 = "close-D3eBE";
var _4 = "login-ZQhu7";
var _5 = "modal-sn6v4";
var _6 = "popup-hRnqo";
var _7 = "standard-QqjCM";
export { _1 as "back", _2 as "body", _3 as "close", _4 as "login", _5 as "modal", _6 as "popup", _7 as "standard" }
